export default __webpack_public_path__ + "static/media/arrow-prev.14fa3bcf.svg";